import React from 'react'
import "./Loader.css"

const Loader = () => {
  return (
    <div className='mainl'>
        <span class="loader"></span>
    </div>
  )
}

export default Loader